/* eslint-disable no-unused-vars */
import Glide, {Autoplay, Breakpoints, Controls, Swipe} from "@glidejs/glide/dist/glide.modular.esm";

const parser = new DOMParser();

function updateActiveBullet(sliderIndex, slideIndex) {
    const selector = `.glide__bullet.of-slider-${sliderIndex}`;
    document.querySelectorAll(selector).forEach((bullet) => {
        bullet.classList.remove('glide__bullet--active');
    });

    const bullet = document.querySelector(`${selector}[data-glide-dir="=${slideIndex}"]`);
    if (bullet) {
        bullet.classList.add('glide__bullet--active');
    }
}

function updateActiveNumber(sliderIndex, slideIndex) {
    const selector = `.glide__number.of-slider-${sliderIndex}`;
    document.querySelectorAll(selector).forEach((bullet) => {
        bullet.classList.remove('glide__number--active');
    });

    const bullet = document.querySelector(`${selector}[data-glide-dir="=${slideIndex}"]`);
    if (bullet) {
        bullet.classList.add('glide__number--active');
    }
}

function stopYoutubeInSlideElement(slide) {
    if (!slide) {
        return;
    }

    slide
        .querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"], iframe[src*="youtu.be"]')
        .forEach((iframe) => {
            const src = iframe.getAttribute('src');
            if (src) {
                // Reload iframe to force-stop playback on inactive slide.
                iframe.setAttribute('src', src);
            }
        });
}

function setSlideKeys(slider, sliderIndex) {
    if (!slider) {
        return;
    }

    const slides = slider.querySelectorAll('.glide__slides > .glide__slide:not(.glide__slide--clone)');
    slides.forEach((slide, index) => {
        slide.dataset.slideKey = `${sliderIndex}-${index}`;
    });
}

function getSlideKeyByIndex(slider, slideIndex) {
    if (!slider || typeof slideIndex !== 'number') {
        return null;
    }

    const slides = slider.querySelectorAll('.glide__slides > .glide__slide:not(.glide__slide--clone)');
    const slide = slides[slideIndex];
    return slide ? slide.dataset.slideKey : null;
}

function updateActiveSlideClass(slider, slideIndex) {
    if (!slider) {
        return;
    }

    slider.querySelectorAll('.glide__slide.is-active-slide').forEach((slide) => {
        slide.classList.remove('is-active-slide');
    });

    const activeSlideKey = getSlideKeyByIndex(slider, slideIndex);
    if (!activeSlideKey) {
        return;
    }

    slider.querySelectorAll(`.glide__slide[data-slide-key="${activeSlideKey}"]`).forEach((slide) => {
        slide.classList.add('is-active-slide');
    });
}

function stopYoutubeForSlideKey(slider, slideKey) {
    if (!slider || !slideKey) {
        return;
    }

    slider.querySelectorAll(`.glide__slide[data-slide-key="${slideKey}"]`).forEach((slide) => {
        stopYoutubeInSlideElement(slide);
    });
}

function initSlider(slider) {
    console.log('init slider');
    try {
        // Determine sliderIndex early so generated bullets have stable class
        const sliderIndex = Array.from(document.querySelectorAll('.glide')).indexOf(slider);

        // Count slides (li elements) to decide whether to init
        const parsed = parser.parseFromString(slider.innerHTML, 'text/html');
        const slidesCount = parsed.querySelectorAll('li').length;

        if (slidesCount <= 1) {
            // nothing to init, but make visible
            slider.style.visibility = 'visible';
            slider.dataset.glideInitialized = 'true';
            return;
        }

        // If there's no glide track wrapper yet, wrap existing innerHTML
        if (!slider.querySelector('[data-glide-el="track"]')) {
            slider.innerHTML = `
        <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
                ${slider.innerHTML}
            </ul>
        </div>
        
     ${slider.dataset.controls === 'true' ?
                `<div class="glide__bullets" data-glide-el="controls[nav]">
                ${[...Array(slidesCount).keys()].map((_, i) => `<button class="glide__bullet of-slider-${sliderIndex}" data-glide-dir="=${i}"></button>`).join('')}
            </div>` : ''}
    
            ${slider.dataset.arrows === 'true' ?
                `<div class="glide__arrows--wrapper">
    <div class="glide__arrows" data-glide-el="controls">
        <button class="glide__arrow glide__arrow--left" data-glide-dir="<"></button>
    
            <span class="glide__numbers">
             ${[...Array(slidesCount).keys()].map((_, i) => `<span class="glide__number of-slider-${sliderIndex}" data-glide-dir="=${i}">${i + 1}.</span>`).join('')}
            </span>
        <button class="glide__arrow glide__arrow--right" data-glide-dir=">"></button>
      </div></div>` : ''}
    `;
        }

        setSlideKeys(slider, sliderIndex);

        const perView = parseInt(slider.dataset.perview ?? '1', 10);

        const options = {
            type: 'carousel',
            rewindDuration: 0,
            hoverpause: false,
            perView,
            gap: parseInt(slider.dataset.gap && perView > 1 ? slider.dataset.gap : '30'),
            autoplay: (slider.dataset.autoplay ?? 5) * 1000,
        };

        if (perView > 1) {
            options.breakpoints = {
                992: {perView: 2},
                720: {perView: 1}
            };
        }

        if ('fade' === slider.dataset.transition) {
            options.animationDuration = 0;
        }

        const glide = new Glide(slider, options);
        let previousSlideKey = null;
        updateActiveNumber(sliderIndex, glide.index);
        updateActiveSlideClass(slider, glide.index);
        glide.on('run.before', () => {
            previousSlideKey = getSlideKeyByIndex(slider, glide.index);
        });
        glide.on('run', () => {
            updateActiveBullet(sliderIndex, glide.index);
            updateActiveNumber(sliderIndex, glide.index);
        });
        glide.on('run.after', () => {
            updateActiveSlideClass(slider, glide.index);

            const activeSlideKey = getSlideKeyByIndex(slider, glide.index);
            if (previousSlideKey && previousSlideKey !== activeSlideKey) {
                stopYoutubeForSlideKey(slider, previousSlideKey);
            }
        });
        glide.on('mount.after', () => {
            updateActiveSlideClass(slider, glide.index);
        });

        glide.mount({Controls, Autoplay, Swipe, Breakpoints});

        slider.style.visibility = 'visible';
        updateActiveSlideClass(slider, glide.index);
    } catch (err) {
    }
}

function initAll() {
    console.log('init all');
    document.querySelectorAll('.glide').forEach(initSlider);
}

initAll();
